module.exports = "https://static.wanderu.com/ui-react/_next/static/media/cnn-money-x2.23b19cb9.png";